import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cbe26c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-3" }
const _hoisted_2 = {
  key: 0,
  class: "skeleton"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skeleton-title" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skeleton-main mt-3" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skeleton-description mt-3" }, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "pt-3 d-flex flex-column"
}
const _hoisted_7 = { class: "d-flex flex-column align-items-center mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-20 font-weight-bold" }, "応募可能まで", -1))
const _hoisted_9 = { class: "text-mild text-size-20 font-weight-bold" }
const _hoisted_10 = { class: "mx-1 text-size-32 step" }
const _hoisted_11 = { class: "d-flex justify-content-center" }
const _hoisted_12 = { class: "mt-3 text-center text-primary text-size-12 font-weight-bold" }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "現在のステータス", -1))
const _hoisted_15 = { class: "py-3 d-flex justify-content-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-32" }, "審査中", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "\n            認証されるまでお待ちください\n          ", -1))
const _hoisted_18 = { class: "py-3 d-flex justify-content-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-32" }, "認証済み", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "\n            お仕事にご応募可能です\n          ", -1))
const _hoisted_21 = { class: "section px-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14 text-weight-500 mt-4 mb-1" }, "\n      登録状況の確認\n    ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-mild text-size-10 pr-2" }, [
  /*#__PURE__*/_createTextVNode("\n      「未登録」「差戻し項目あり」の場合はタップして登録に進んでください"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n      アカウント・資格認証は約1時間以内に完了します\n    ")
], -1))
const _hoisted_24 = { class: "bg-white border border-outline-color px-3 mt-1 round-4" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "アカウント情報", -1))
const _hoisted_26 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "資格証", -1))
const _hoisted_28 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "給与口座", -1))
const _hoisted_30 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "経験・転職意欲", -1))
const _hoisted_32 = { class: "d-flex justify-content-end align-items-center" }

import { computed } from "vue";
import type { PropType } from "vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import StepBar from "@/components/organisms/mypage/StepBar.vue";
import BgWaveCard from "@/components/organisms/common/BgWaveCard.vue";
import VerifiedStatusLabel from "@/components/organisms/mypage/VerifiedStatusLabel.vue";
import verifiedStatus from "@/models/verifiedStatus";
import { User } from "@/types/user/User";

type StatusLabel = "未登録" | "審査中" | "差戻し項目あり" | "認証済み" | "登録済み";


export default /*#__PURE__*/_defineComponent({
  __name: 'VerificationAccountStep',
  props: {
  isLoading: {
    type: Boolean,
    required: true
  },
  user: {
    type: Object as PropType<User>,
    required: true
  },
  hasBankAccount: {
    type: Boolean,
    required: true
  }
},
  setup(__props) {

const props = __props;

const toRegisterProfileRoute = { name: "RegistrationInformationAndStatus" };



const isUserStatusUnverified = computed<boolean>(() => {
  return props.user.verifiedStatus === verifiedStatus.UNVERIFIED;
});
const isUserStatusRejected = computed<boolean>(() => {
  return props.user.verifiedStatus === verifiedStatus.REJECTED;
});
const isUserStatusVerified = computed<boolean>(() => {
  return props.user.verifiedStatus === verifiedStatus.VERIFIED;
});
const userVerifiedStatusLabel = computed<StatusLabel | null>(() => {
  if (props.isLoading) return null;
  if (!props.user.hasRegisteredProfile) return "未登録";
  if (isUserStatusUnverified.value) return "審査中";
  if (isUserStatusRejected.value) return "差戻し項目あり";
  if (isUserStatusVerified.value) return "認証済み";
  // 通常起こりえない
  return null;
});
const hasRejectedQualification = computed<boolean>(() => {
  return props.user.qualifications.some(qualification => {
    return qualification.status === verifiedStatus.REJECTED;
  });
});
const hasUnverifiedQualification = computed<boolean>(() => {
  return props.user.qualifications.some(qualification => {
    return qualification.status === verifiedStatus.UNVERIFIED;
  });
});
const hasVerifiedQualification = computed<boolean>(() => {
  return props.user.qualifications.some(qualification => {
    return qualification.status === verifiedStatus.VERIFIED;
  });
});
const allVerifiedQualifications = computed<boolean>(() => {
  if (props.user.qualifications.length === 0) {
    return false;
  }
  return props.user.qualifications.every(qualification => {
    return qualification.status === verifiedStatus.VERIFIED;
  });
});
const qualificationStatusLabel = computed<StatusLabel | null>(() => {
  if (props.isLoading) return null;
  if (props.user.qualifications.length === 0) return "未登録";
  if (hasRejectedQualification.value) return "差戻し項目あり";
  if (hasUnverifiedQualification.value) return "審査中";
  if (allVerifiedQualifications.value) return "認証済み";
  // 通常起こりえない
  return null;
});
const qualificationStatusLabelType = computed(() => {
  if (!qualificationStatusLabel.value) {
    return undefined;
  }
  if (hasUnverifiedQualification.value) {
    return "notice";
  }
  if (allVerifiedQualifications.value) {
    return "success"
  }
  return "danger";
});
const userBankAccountInfoLabel = computed<StatusLabel | null>(() => {
  if (props.isLoading) return null;
  return props.hasBankAccount ? "登録済み" : "未登録";
});
const userBusinessInfoLabel = computed<StatusLabel | null>(() => {
  if (props.isLoading) return null;
  return props.user.experiences.length > 0 ? "登録済み" : "未登録";
});
const isIncrementStepByQualification = computed(() => {
  // 資格が0件
  if (props.user.qualifications.length === 0) {
    return true;
  }
  // 認証済み資格が無く、差戻し資格がある
  return !hasVerifiedQualification.value && hasRejectedQualification.value;
});
const remainingSteps = computed<number>(() => {
  return [
    userVerifiedStatusLabel.value !== null && !["審査中", "認証済み"].includes(userVerifiedStatusLabel.value),
    isIncrementStepByQualification.value,
    userBankAccountInfoLabel.value === "未登録",
    userBusinessInfoLabel.value === "未登録"
  ].filter(c => c).length;
});
const underExaminationSteps = computed<number>(() => {
  return [
    userVerifiedStatusLabel.value === "審査中",
    hasUnverifiedQualification.value, // ここでは認証済み資格の有無は問わない
  ].filter(c => c).length;
});
const summaryText = computed(() => {
  return `${4 - remainingSteps.value} / 4${underExaminationSteps.value > 0 ? ` (${underExaminationSteps.value}項目審査中)` : ""}`;
});
const isShowUnderExamination = computed(() => {
  // 審査中の項目なし
  if (underExaminationSteps.value === 0) {
    return false;
  }
  // アカウント認証の審査中
  if (userVerifiedStatusLabel.value === "審査中") {
    return true;
  }
  // 以降は資格の審査中
  // この場合、認証済み資格があれば応募可能とみなし、審査中表示は行わない
  return !hasVerifiedQualification.value;
});

function getLabelType(label: StatusLabel) {
  return {
    "認証済み": "success",
    "登録済み": "success",
    "審査中": "notice",
    "未登録": "danger",
    "差戻し項目あり": "danger"
  }[label] as "success" | "notice" | "danger" || undefined;
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BgWaveCard, { class: "mt-3 mb-4" }, {
        default: _withCtx(() => [
          (__props.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(),
                _hoisted_4,
                _createTextVNode(),
                _hoisted_5
              ]))
            : (remainingSteps.value > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createTextVNode(),
                    _createElementVNode("p", _hoisted_9, [
                      _createTextVNode("\n            あと"),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(remainingSteps.value), 1),
                      _createTextVNode("ステップ\n          ")
                    ])
                  ]),
                  _createTextVNode(),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(StepBar, {
                      class: "w-75",
                      maxValue: 5,
                      currentValue: 5 - remainingSteps.value,
                      reverse: ""
                    }, null, 8, ["currentValue"])
                  ]),
                  _createTextVNode(),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(summaryText.value), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createTextVNode(),
                  (isShowUnderExamination.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(FeatherIcon, {
                            icon: "circle",
                            size: "3x",
                            class: "text-yellow pr-2"
                          }),
                          _createTextVNode(),
                          _hoisted_16
                        ]),
                        _createTextVNode(),
                        _hoisted_17
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(FeatherIcon, {
                            icon: "check-circle",
                            size: "3x",
                            class: "text-green pr-2"
                          }),
                          _createTextVNode(),
                          _hoisted_19
                        ]),
                        _createTextVNode(),
                        _hoisted_20
                      ], 64))
                ]))
        ], undefined, true),
        _: 1
      })
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _createTextVNode(),
      _hoisted_23,
      _createTextVNode(),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_RouterLink, {
          to: toRegisterProfileRoute,
          class: "d-flex justify-content-between align-items-center py-3"
        }, {
          default: _withCtx(() => [
            _hoisted_25,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_26, [
              (userVerifiedStatusLabel.value)
                ? (_openBlock(), _createBlock(VerifiedStatusLabel, {
                    key: 0,
                    text: userVerifiedStatusLabel.value,
                    type: getLabelType(userVerifiedStatusLabel.value)
                  }, null, 8, ["text", "type"]))
                : _createCommentVNode("", true),
              _createTextVNode(),
              _createVNode(FeatherIcon, {
                icon: "chevron-right",
                size: "1x",
                class: "text-gray-05 ml-2"
              })
            ])
          ], undefined, true),
          _: 1
        }),
        _createTextVNode(),
        _createVNode(_component_RouterLink, {
          to: { name: 'MypageQualificationList' },
          class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3"
        }, {
          default: _withCtx(() => [
            _hoisted_27,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_28, [
              (qualificationStatusLabel.value)
                ? (_openBlock(), _createBlock(VerifiedStatusLabel, {
                    key: 0,
                    text: qualificationStatusLabel.value,
                    type: qualificationStatusLabelType.value
                  }, null, 8, ["text", "type"]))
                : _createCommentVNode("", true),
              _createTextVNode(),
              _createVNode(FeatherIcon, {
                icon: "chevron-right",
                size: "1x",
                class: "text-gray-05 ml-2"
              })
            ])
          ], undefined, true),
          _: 1
        }),
        _createTextVNode(),
        _createVNode(_component_RouterLink, {
          to: { name: 'SetBank' },
          class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3"
        }, {
          default: _withCtx(() => [
            _hoisted_29,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_30, [
              (userBankAccountInfoLabel.value)
                ? (_openBlock(), _createBlock(VerifiedStatusLabel, {
                    key: 0,
                    text: userBankAccountInfoLabel.value,
                    type: getLabelType(userBankAccountInfoLabel.value)
                  }, null, 8, ["text", "type"]))
                : _createCommentVNode("", true),
              _createTextVNode(),
              _createVNode(FeatherIcon, {
                icon: "chevron-right",
                size: "1x",
                class: "text-gray-05 ml-2"
              })
            ])
          ], undefined, true),
          _: 1
        }),
        _createTextVNode(),
        _createVNode(_component_RouterLink, {
          to: { name: 'MypageBusinessInfo' },
          class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3"
        }, {
          default: _withCtx(() => [
            _hoisted_31,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_32, [
              (userBusinessInfoLabel.value)
                ? (_openBlock(), _createBlock(VerifiedStatusLabel, {
                    key: 0,
                    text: userBusinessInfoLabel.value,
                    type: getLabelType(userBusinessInfoLabel.value)
                  }, null, 8, ["text", "type"]))
                : _createCommentVNode("", true),
              _createTextVNode(),
              _createVNode(FeatherIcon, {
                icon: "chevron-right",
                size: "1x",
                class: "text-gray-05 ml-2"
              })
            ])
          ], undefined, true),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})